module.exports = __webpack_public_path__ + "img/button_joimax.96ff914c.svg";